(ns practitest.frontend.reports.main
  (:require [practitest.frontend.components2.spinners :as spinners]
            [practitest.frontend.reports.events]
            [practitest.frontend.reports.subs]
            [practitest.frontend.reports.views :as views]
            [practitest.frontend.common-old-fe.i18n :as i18n]
            [re-frame.core :as re-frame]
            [re-frame.db]
            [reagent-modals.modals   :refer [close-modal!]]))

(def main-controller
  {:stop (fn [_]
           (re-frame/dispatch [:reports/cleanup]))})

(defn reports-view []
  (if-let [_init-done? @(re-frame/subscribe [:reports/init-complete?])]
    [views/main-panel]
    [:div.loader
      [spinners/mux-spinner {:size :modal}]]))

(defn ^:export legacy-init [config translation]
  (close-modal!)
  (i18n/initialize (js->clj translation :keywordize-keys true))
  (re-frame/dispatch [:reports/initialize (js->clj config :keywordize-keys true)])
  (re-frame/dispatch [:reports/init-complete]))
